<template lang="html">
  <boxwrap class="countries--inner">
    <toolbar>
      <toolbar-items class="-searchbar">
        <search
          class="search-bar-wrap -withdropdown"
          :dateBy="dateBy"
          :filterBy="filterBy"
        >
        </search>
        <button
          class="btn--create"
          title="create"
          @click="showCreate = true"
        >
          <i class="ico--create"></i>
        </button>

        <div class="toolbar-rightbtns">
          <button
            class="btn--import-csv"
          >
            <i class="ico--import"></i>
          </button>

          <button
            class="btn--export-csv"
          >
            <i class="ico--export"></i>
          </button>

          <button
            class="btn--tbl-settings"
            @click="showTblSettings = true"
          >
            <i class="ico--settings"></i>
          </button>
        </div>
      </toolbar-items>
    </toolbar>

    <boxwrap-contents
    >
      <tbl
        :scrollable="true"
      >
        <tbl-inner>
          <tbl-head>
            <tbl-row>
              <tbl-td
                name="id"
              >
                id
              </tbl-td>
              <tbl-td
                name="image"
              >
                image
              </tbl-td>
              <tbl-td
                name="name"
              >
                name
              </tbl-td>
              <tbl-td
                name="korean-name"
              >
                korean name
              </tbl-td>
              <tbl-td
                name="date"
              >
                date
              </tbl-td>
              <tbl-td
                name="create-at"
              >
                create at
              </tbl-td>
            </tbl-row>
          </tbl-head>
          <tbl-body>
            <tbl-row
              @click.native="showModifyPopup()"
            >
              <tbl-td
                name="id"
              >
                id
              </tbl-td>
              <tbl-td
                name="image"
              >

              </tbl-td>
              <tbl-td
                name="name"
              >
                name
              </tbl-td>
              <tbl-td
                name="korean-name"
              >
                korean name
              </tbl-td>
              <tbl-td
                name="date"
              >
                date
              </tbl-td>
              <tbl-td
                name="create-at"
              >
                create at
              </tbl-td>
            </tbl-row>
          </tbl-body>
        </tbl-inner>
      </tbl>
    </boxwrap-contents>
    <modal
      class="modal--create"
      title="Add country"
      v-if="showCreate"
      :activate="showCreate"
      @activate="showCreate = $event"
    >
      <template slot="body">
        <form
          class="form-con"
        >
          <div class="form-items">
            <div class="form-lbl"><span>name</span></div>
            <div class="form-data">
              <div class="input-wrap">
                <input type="text" />
              </div>
            </div>
          </div>
          <div class="form-items">
            <div class="form-lbl"><span>korean name</span></div>
            <div class="form-data">
              <div class="input-wrap">
                <input type="text" />
              </div>
            </div>
          </div>
          <div class="form-items">
            <div class="form-lbl"><span>Image</span></div>
            <div class="form-data">
              <div class="input-wrap">
                <label for="country-upload" class="form--file-label">
                  <button class="btn--file -withlabel"><i class="ico--upload"></i><span>upload</span></button>
                  <input type="file" id="country-upload" class="form--file-input">
                </label>
              </div>
            </div>

          </div>
        </form>
      </template>
      <template slot="footer">
        <button
          class="btn--create -withlabel"
        >
          <i class="ico--create"></i>
          <span>Add country</span>
        </button>
      </template>
    </modal>

    <modal
      class="modal--country"
      title="modify country"
      v-if="showModify"
      :activate="showModify"
      @activate="showModify = $event"
    >
      <template slot="body">
        <form
          class="form-con"
        >
          <div class="form-items">
            <div class="form-lbl"><span>name</span></div>
            <div class="form-data">
              <div class="input-wrap">
                <input type="text" />
              </div>
            </div>
          </div>
          <div class="form-items">
            <div class="form-lbl"><span>korean name</span></div>
            <div class="form-data">
              <div class="input-wrap">
                <input type="text" />
              </div>
            </div>
          </div>
          <div class="form-items">
            <div class="form-lbl"><span>Image</span></div>
            <div class="form-data">
              <div class="input-wrap">
                <label for="country-upload" class="form--file-label">
                  <button class="btn--file -withlabel"><i class="ico--upload"></i><span>upload</span></button>
                  <input type="file" id="country-upload" class="form--file-input">
                </label>
              </div>
            </div>

          </div>
        </form>
      </template>
      <template slot="footer">
        <button
          class="btn--modify -withlabel"
        >
          <i class="ico--save"></i>
          <span>Modify</span>
        </button>
      </template>
    </modal>

    <table-settings
      :showTblSettings="showTblSettings"
      :allCols="allCols"
      :tblSetting="tblSetting"
      :activate="showTblSettings"
      v-if="modConfig.tableConfig"
      @activate="showTblSettings = $event"
      @load="showLoad()"
    >
    </table-settings>
  </boxwrap>
</template>

<script>
import Pagination from '@/components/base/Pagination'
import Search from '@/components/base/search/Search'
import Modal from '@/components/base/Modal'

import '@/components/common/table-settings/TableSettings'

export default {
  name: 'Countries',

  components: {
    Pagination,
    Search,
    Modal
  },

  data () {
    return {
      isDataLoading: true,
      isEmpty: false,
      showDataLoading: false,

      showTblSettings: false,
      showCreate: false,
      showModify: false,

      tblSetting: 'country_list',

      filterBy: [
        {
          value: 'id',
          display: 'id'
        },

        {
          value: 'name',
          display: 'name'
        },

        {
          value: 'korean_name',
          display: 'korean name'
        }
      ],

      dateBy: [
        {
          value: 'created_at',
          display: 'created at'
        }
      ],

      allCols: [
        {
          display: 'id',
          value: 'id'
        },
        {
          display: 'image',
          value: 'image'
        },
        {
          display: 'name',
          value: 'name'
        },
        {
          display: 'korean name',
          value: 'korean_name'
        },
        {
          display: 'date',
          value: 'date'
        },
        {
          display: 'created at',
          value: 'created_at'
        }
      ]
    }
  },

  computed: {

  },

  watch: {

  },

  methods: {
    showModifyPopup (game) {
      this.showModify = true
    }
  }
}
</script>

<style lang="css" scoped>
</style>
